module.exports = __webpack_public_path__ + "media/images/home/cloud-8eee44642b28e4023a31af2c4de24719.png";